import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { translate } from 'react-i18next';
import { Col, Row } from 'react-flexbox-grid';
import { accountRoles } from '../../../common/enums';

import config from '../../../config';
import { 
  selectAccountNumber,
  selectAccountRole
 } from '../../../features/auth/ducks';

const PaymentInstructions = ({ t, accountNumber, role }) => (
  <section className="panel-wrapper text-center">
    {(role === accountRoles.EXECUTOR) && <h2>{t('Vykonanie platby')}</h2>}
    {(role !== accountRoles.EXECUTOR) && <h2>{t('Dotácia investičného účtu')}</h2>}
    <Row center="xs">
      <Col xs={12} sm={9}>
        <p className="col-sm-11 center">
          {t(
            'Pre navýšenie stavu účtu pošlite, prosím, finančné prostriedky na Váš virtuálny účet.'
          )}
        </p>
        <h3>
          {t('Číslo účtu')}: {config.IBAN}
        </h3>
        <h3>
          {t('Názov účtu')}: Peer2Peer, s.r.o.
        </h3>
        <h3>
          {t('Variabilný symbol')}: {accountNumber}
        </h3>
      </Col>
    </Row>
  </section>
);

PaymentInstructions.propTypes = {
  t: PropTypes.func.isRequired,
  accountNumber: PropTypes.string.isRequired,
  role: PropTypes.string.isRequired
};

const mapStateToProps = state => ({
  accountNumber: selectAccountNumber(state),
  role: selectAccountRole(state),
});

export default translate()(connect(mapStateToProps)(PaymentInstructions));



// WEBPACK FOOTER //
// ./src/features/allocations/components/PaymentInstructions.js